
import { INJECTABLE_SECTIONS } from './type';
import { POST_SECTOR_TYPE } from '@/components/sections/SectionWithHubspotPosts';

/**
 * This object allow us to manually customize components which accept a React child, in a generic page.
 * The first key must be the name of the page we want to customize.
 * The second key must be the id / name of the customizable component.
 */
// home: {
// 	ComponentSectionIntro: (
// 		<div>
// 			inject content and data here !
// 		</div>
// 	),
// },
export const customReactElementPerPage: { [key: string]: any } = {};

/**
 * This object allow us to manually customize and inject sections inside a Strapi generated page.
 * The first key is the targeted page, or the suffix of the page group.
 * The second key is the index / position to inject the inject at.
 * And then the properties we want to add.
 */
export const sectionsToInsertPerPage: { [index: string]: any } = {
	'home_talent': {
		1: {
			__typename: INJECTABLE_SECTIONS.MISSION_CARDS_PREVIEW,
			backgroundColor: {
				color: 'white',
			},
			buttons: [
				{
					newTab: false,
					text: 'Voir toutes nos offres',
					trackerId: null,
					url: 'offres',
					variant: 'whiteOnRed',
				},
			],
			cards: {
				limit: 6,
			},
			title: {
				titlePieces: [
					{ text: 'Nos dernières', isUnderlined: false },
					{ text: 'offres', isUnderlined: true },
					{ text: 'd\'emploi', isUnderlined: false },
				],
				underlineColor: 'red',
			},
		},
	},
	'home_talent-en': {
		1: {
			__typename: INJECTABLE_SECTIONS.MISSION_CARDS_PREVIEW,
			backgroundColor: {
				color: 'white',
			},
			buttons: [
				{
					newTab: false,
					text: 'See all our offers',
					trackerId: null,
					url: 'offers',
					variant: 'whiteOnRed',
				},
			],
			cards: {
				limit: 6,
			},
			title: {
				titlePieces: [
					{ text: 'Our last', isUnderlined: false },
					{ text: 'jobs', isUnderlined: true },
					{ text: 'offers', isUnderlined: false },
				],
				underlineColor: 'red',
			},
		},
	},
	'home_talent-es': {
		1: {
			__typename: INJECTABLE_SECTIONS.MISSION_CARDS_PREVIEW,
			backgroundColor: {
				color: 'white',
			},
			buttons: [
				{
					newTab: false,
					text: 'Ver todas nuestras ofertas',
					trackerId: null,
					url: 'ofertas',
					variant: 'whiteOnRed',
				},
			],
			cards: {
				limit: 6,
			},
			title: {
				titlePieces: [
					{ text: 'Nuestras', isUnderlined: false },
					{ text: 'ofertas', isUnderlined: true },
					{ text: 'de empleo', isUnderlined: false },
				],
				underlineColor: 'red',
			},
		},
	},
	'secteur-b2b_hcr': {
		4: {
			__typename: INJECTABLE_SECTIONS.HUBSPOT_BLOG_POSTS,
			category: POST_SECTOR_TYPE.hcr,
			limit: 3,
			tagId: '61981690172',
			title: {
				titlePieces: [
					{ text: 'Découvrez nos derniers', isUnderlined: false },
					{ text: 'articles', isUnderlined: true },
					{ text: 'de blog', isUnderlined: false },
				],
				underlineColor: 'red',
			},
		},
	},
};

/**
 * This is a predefined object model for the summary section which is being manually injected.
 */
export const summarySectionInsertModel = {
	2: {
		__typename: INJECTABLE_SECTIONS.SUMMARY,
	},
};
